export default __webpack_public_path__ + "static/ic_location_pin-0f04181696a6f7bf114c768c2b53da2c.png";